import styled from 'styled-components'

type Props = {
	height: number
}

export const Image = styled.img<Props>`
	height: ${({ height }) => height}px;
	object-fit: contain;
	display: inline-block;
	vertical-align: middle;
`
